<template>
    <div>

        <el-tabs v-model="activeTabName" class="demo-tabs" @tab-click="onTabClick">
            <el-tab-pane label="档案信息" name="User" />
            <el-tab-pane label="任职信息" name="Appointment" />
            <el-tab-pane label="调离信息" name="Transfer" />
            <el-tab-pane label="相关学历及职业技能证书" name="Certificate" />
            <el-tab-pane label="工作成长记录" name="WorkResume" />
            <el-tab-pane label="家庭成员" name="Family" />
            <el-tab-pane label="变动信息" name="Records" />
            <el-tab-pane label="人事合同" name="Contract" />
        </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button type=" " icon="el-icon-close" @click="dialogFormVisible=false">关 闭</el-button>
    	<el-button type="primary" icon="el-icon-check" @click="handleSubmitClose">保存关闭</el-button>
        <el-button type="primary" icon="el-icon-check" @click="handleSubmit">保 存</el-button>
      </div>
    </div>
</template>

<script>

const moment = require('moment')
export default {
    components: {
    },
    props: {
        //vo: { type: Object, default: function() { return {} } },
        //canEdit: { type: Number, default: 1 },
        //moduleInfo: { type: Object, default: function() { return {} } }
    },
    data: function() {
        return {
            loginUser: this.$store.getters.loginUser,
            activeTabName: 'User',
            vo: {},
            dialogFormVisible: false,
            type: '', //1编辑，2新增
            workData: {}
        }
    },
    computed: {},
    watch: {},
    created: function() {
        // this.$bus.$on('openTeacherForm',(params)=>{
        //     console.log('params',params)
        //     if(params){
        //         this.dialogFormVisible = true;
        //     }
        // })
        // if(this.$parent.$vnode.context.activeTabIndex){
        //     this.activeTabName = this.$parent.$vnode.context.activeTabIndex
        // }

        // this.$set(this.$vnode.context,"wfAttach",false)
    },
    beforeDestroy: function() {
        this.$bus.$off('showTeacherFormDialog')
    },
    mounted: function() {
        this.$http({
            	method: 'post',
            	url: '/xsgl/teacherWorkResume/listdata'
        }).then(res => {
            	if (res.code === 'success') {
            		this.$message.success(res.message)
            	} else {
            		this.$message.error(res.message)
            	}
        })

        let _this = this
        _this.$bus.$on('showTeacherFormDialog', (params) => {
            console.log('params', params)
            _this.type = params.type
            if (params) {
                _this.dialogFormVisible = true
            }
            if (params.type == 1) {
                _this.vo = {...params.detail}
            }
        })
    },
    methods: {
        closeShow(type) {
            if (type == 1) {
                	//this.dialogFormVisible=false
            } else {
                	//this.dialogFormVisible=true
            }
        },
        showTeacherFormDialog: function(val) {
            console.log('archiveInfo form opened')
        },
        onTabClick: function(tab) {
            this.activeTabName = tab.name
            if (this.activeTabName == 'Appointment' && this.type == 1) {
                this.$http({
                    	method: 'get',
                    	url: '/xsgl/teacherAppointmentInfo/getById?teacherId=' + this.vo.id
                }).then(res => {
                    	// if(res.code==='success'){
                    	// 	this.$message.success(res.message)
                    	// }else{
                    	// 	this.$message.error(res.message)
                    	// }
                    //    if(type==1){
                    //      this.dialogFormVisible = false
                    //    }
                })
            }
            // if(this.$parent.$vnode.context.onTabClick){
            // 	this.$parent.$vnode.context.onTabClick(tab)
            // }
        },
        //提交表单 type=1 关闭弹窗
        submitForm(type) {
            if (this.activeTabName == 'User') {
                //this.vo.teacherId = 1010;
                this.vo.appointmentDate = moment(this.vo.appointmentDate).format('YYYY-MM-DD')
                this.vo.birthDate = moment(this.vo.birthDate).format('YYYY-MM-DD')
                this.vo.startDate = moment(this.vo.startDate).format('YYYY-MM-DD')
                this.vo.endDate = moment(this.vo.endDate).format('YYYY-MM-DD')
                console.log('this.rowDetial', this.vo)
                this.$http({
                    	method: 'post',
                    	url: '/xsgl/teacherBasicInfo/insert',
                    	data: this.vo
                }).then(res => {
                    	if (res.code === 'success') {
                    		this.$message.success(res.message)
                    	} else {
                    		this.$message.error(res.message)
                    	}
                    if (type == 1) {
                        this.dialogFormVisible = false
                    }
                })
            } else if (this.activeTabName == 'Appointment') {
                // this.vo.dispatchDate = moment(this.vo.dispatchDate).format('YYYY-MM-DD')
                // this.vo.confirmationDate = moment(this.vo.confirmationDate).format('YYYY-MM-DD')
                // this.vo.entryDate = moment(this.vo.entryDate).format('YYYY-MM-DD')
                // console.log('this.rowDetial',this.vo)
                // this.$http({
                // 	method:'post',
                // 	url:'/xsgl/teacherAppointmentInfo/insert',
                // 	data:this.vo
                // }).then(res=>{
                // 	if(res.code==='success'){
                // 		this.$message.success(res.message)
                // 	}else{
                // 		this.$message.error(res.message)
                // 	}
                //     if(type==1){
                //       this.dialogFormVisible = false
                //     }
                // })
            } else if (this.activeTabName == 'Transfer') {
                this.vo.transferDate = moment(this.vo.transferDate).format('YYYY-MM-DD')
                this.vo.expectedRetirementDate = moment(this.vo.expectedRetirementDate).format('YYYY-MM-DD')
                console.log('this.rowDetial', this.vo)
                this.$http({
                    	method: 'post',
                    	url: '/xsgl/teacherTransferInfo/insert',
                    	data: this.vo
                }).then(res => {
                    	if (res.code === 'success') {
                    		this.$message.success(res.message)
                    	} else {
                    		this.$message.error(res.message)
                    	}
                    if (type == 1) {
                        this.dialogFormVisible = false
                    }
                })
            } else if (this.activeTabName == 'JobResume') {
                // this.vo.transferDate = moment(this.vo.transferDate).format('YYYY-MM-DD')
                // this.vo.expectedRetirementDate = moment(this.vo.expectedRetirementDate).format('YYYY-MM-DD')
                // let _data = {...this.form};
                // _data.startDate = _data.startDate?moment(_data.startDate).format('YYYY-MM-DD'):'';
                // _data.endDate = _data.endDate?moment(_data.endDate).format('YYYY-MM-DD'):'';
                // _data.teacherBasicInfoId = this.vo.id;
                // _data.name = this.vo.teacherName;
                // _data.teacherId = this.vo.teacherId;
                console.log('workData', this.workData)
                // this.$http({
                // 	method:'post',
                // 	url:'/xsgl/teacherWorkResume/insert',
                // 	data:this.vo
                // }).then(res=>{
                // 	if(res.code==='success'){
                // 		this.$message.success(res.message)
                // 	}else{
                // 		this.$message.error(res.message)
                // 	}
                //     if(type==1){
                //       this.dialogFormVisible = false
                //     }
                // })
            } else if (this.activeTabName == 'Family') {
                // this.vo.birthDate = moment(this.vo.birthDate).format('YYYY-MM-DD')
                // console.log('this.Family',this.vo)
                // this.$http({
                // 	method:'post',
                // 	url:'/xsgl/teacherFamilyMembers/insert',
                // 	data:this.vo
                // }).then(res=>{
                // 	if(res.code==='success'){
                // 		this.$message.success(res.message)
                // 	}else{
                // 		this.$message.error(res.message)
                // 	}
                //     if(type==1){
                //       this.dialogFormVisible = false
                //     }
                // })
            } else if (this.activeTabName == 'Records') {
                this.vo.transferDate = moment(this.vo.transferDate).format('YYYY-MM-DD')
                this.vo.expectedRetirementDate = moment(this.vo.expectedRetirementDate).format('YYYY-MM-DD')
                console.log('this.Records', this.vo)
                this.$http({
                    	method: 'post',
                    	url: '/xsgl/teacherChangeRecords/insert',
                    	data: this.vo
                }).then(res => {
                    	if (res.code === 'success') {
                    		this.$message.success(res.message)
                    	} else {
                    		this.$message.error(res.message)
                    	}
                    if (type == 1) {
                        this.dialogFormVisible = false
                    }
                })
            } else if (this.activeTabName == 'Contract') {
                this.vo.transferDate = moment(this.vo.transferDate).format('YYYY-MM-DD')
                this.vo.expectedRetirementDate = moment(this.vo.expectedRetirementDate).format('YYYY-MM-DD')
                console.log('this.Contract', this.vo)
                this.$http({
                    	method: 'post',
                    	url: '/xsgl/teacherContractInfo/insert',
                    	data: this.vo
                }).then(res => {
                    	if (res.code === 'success') {
                    		this.$message.success(res.message)
                    	} else {
                    		this.$message.error(res.message)
                    	}
                    if (type == 1) {
                        this.dialogFormVisible = false
                    }
                })
            } else if (this.activeTabName == 'Certificate') {
                // this.vo.transferDate = moment(this.vo.transferDate).format('YYYY-MM-DD')
                // this.vo.expectedRetirementDate = moment(this.vo.expectedRetirementDate).format('YYYY-MM-DD')
                // console.log('this.Contract',this.vo)
                // this.$http({
                // 	method:'post',
                // 	url:'/xsgl/teacherContractInfo/insert',
                // 	data:this.vo
                // }).then(res=>{
                // 	if(res.code==='success'){
                // 		this.$message.success(res.message)
                // 	}else{
                // 		this.$message.error(res.message)
                // 	}
                //     if(type==1){
                //       this.dialogFormVisible = false
                //     }
                // })
            }
        },
        handleSubmitClose() {
            this.submitForm(1)
        },
        handleSubmit() {
            this.submitForm()
        }

    }
}
</script>

<style scoped>
    .header {
        padding: 6px 20px;
        background-color: #f2f5fb;
        font-size: 15px;
        line-height: 40px;
        border-bottom: 1px solid #d8d8d8;
    }

    /* .el-form-item {
    margin-bottom: 0 !important;
}
.borderless-input >>> .el-input__inner {
  border: none !important;
  box-shadow: none !important;
} */
</style>
